@if (component) {
<div class="wrap flex p-t-10 p-b-10 p-t-3-m p-t-3-s p-b-3-m p-b-3-s"
     [style.background-color]="component.backgroundColor || null">
    <div class="w-12 flex-column">
        <h2 class="p-b-6-x p-b-6-l center-x center-l"
            *iCms="'header' of component; skipEmpty: true"
            [ngClass]="component.headerSize || ''">
        </h2>
        <div class="inline-block"
             *ifSize="'XL'">
            @for (column of component.columns; track $index; let j = $index) {
            <ng-container *ifSize="'XL'">
                @if (column?.variant === EVariant.image) {
                <div class="ratio-1-1 w-6">
                    <img class="rf p-a"
                         [image]="column?.image">
                </div>
                }
            </ng-container>
            @if (column?.variant === EVariant.tabs) {
            <div class="w-6 w-12-m w-12-s p-a">
                <div class="p-b-6"
                     *iCms="'header' of column; skipEmpty: true"
                     [ngClass]="column?.headerSize || ''"></div>
                @for (item of column.questions; track $index; let i = $index; let isFirst = $first) {
                <div>
                    <div class="flex flex-middle flex-justify-between b-col-12 p-b-4 p-t-4 cursor-pointer"
                         [toggle]="[toggleGroup + i + j, j ]"
                         [toggleClass]="'!b-b'"
                         [toggleClassBy]="[toggleGroup + i + j, j]">
                        <p class="p-l-2-m p-l-2-s cursor-pointer"
                           [ngClass]="column?.questionSize || 'h5'"
                           *iCms="'question' of item; content: 'html'"></p>
                        <i class="col-12 icon-plus"
                           [toggleClass]="'!icon-plus icon-minus'"
                           [toggleClassBy]="[toggleGroup + i + j, j ]"></i>
                    </div>
                    <div [hideUp]="[toggleGroup + i + j, j ]"
                         [toggleClassBy]="[toggleGroup + i + j, j ]">
                        <div class="p-b-4 b-b b-col-12 col-11"
                             [ngClass]="column?.answerSize || 'p3'"
                             *iCms="'answer' of item; content: 'html'">
                        </div>
                    </div>
                </div>
                }
                <href class="w-12 p-t-10 p2"
                      [link]="column?.ctaLink">
                    <span *iCms="'ctaLabel' of column; content: 'html'; skipEmpty: true"></span>
                </href>
            </div>
            }
            }
            <href [link]="component?.ctaLink">
                <div class="p-t-10 p2"
                     *iCms="'ctaLabel' of component; content: 'html'; skipEmpty: true"></div>
            </href>
        </div>
        <ng-container *ifSize="'MS'">
            @for (column of allQuestions | slice : 0 : displayLimit; track $index; let j = $index) {
            <div class="flex flex-middle flex-justify-between b-col-12 p-b-4 p-t-4 cursor-pointer"
                 [toggle]="[toggleGroup + j, i]"
                 [toggleClass]="'!b-b'"
                 [toggleClassBy]="[toggleGroup + j, i]">
                <p class="cursor-pointer"
                   [ngClass]="column?.questionSize || 'h5'"
                   *iCms="'question' of column; content: 'html'"></p>
                <i class="col-12 icon-plus"
                   [toggleClass]="'!icon-plus icon-minus'"
                   [toggleClassBy]="[toggleGroup + j, i]"></i>
            </div>
            <div [hideUp]="[toggleGroup + j, i]"
                 [toggleClassBy]="[toggleGroup + j, i]">
                <div class="p-b-4 b-b b-col-12"
                     [ngClass]="column?.answerSize || 'p3'"
                     *iCms="'answer' of column; content: 'html'">
                </div>
            </div>
            }
            <href [link]="component?.ctaLink">
                <div class="p-t-2 p3"
                     *iCms="'ctaLabel' of component; content: 'html'; skipEmpty: true"></div>
            </href>
            @if (component.viewMore) {
            <button class="w-12 b-b right p-t-2 p2"
                    (click)="toggleLimit()">
                @if (allQuestions.length !== displayLimit) {
                <span class="b-b b-col-1">{{ 'view more' | translate }}</span>
                }
                @if (allQuestions.length === displayLimit) {
                <span class="b-b b-col-1">{{ 'view less' | translate }}</span>
                }
            </button>
            }
        </ng-container>
    </div>
</div>
}